<template>
  <div class="enterprise-network_container">
    <div class="enterprise-network_container_title">
      Select Country/Region
    </div>
    <div class="enterprise-network_container_content">
      <el-form
        ref="form"
        label-position="top"
        :model="formData"
        :rules="rules"
        :validate-on-rule-change="false"
      >
        <div class="enterprise-network_grid grid-1x2 gap_80">
          <el-form-item prop="country">
            <template #label>
              <div class="enterprise-network-label_required">
                Business Registration Country/Region
              </div>
            </template>
            <el-select
              v-model="formData.country"
              placeholder=""
              filterable
              style="width: 100%"
              default-first-option
              @change="handleCountryChange"
              :disabled="!isSeniorEditor"
            >
              <el-option
                v-for="(item, index) in countryList"
                :key="index"
                :label="item.name"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
          <el-form-item prop="authRegion">
            <template #label>
              <div class="enterprise-network-label_required">
                Authorized Country/Region
              </div>
            </template>
            <el-select
              v-model="formData.authRegion"
              placeholder=""
              clearable
              filterable
              style="width: 100%"
              default-first-option
              @change="handleAuthRegionCountryChange"
              multiple
              :disabled="!isSeniorEditor"
            >
              <el-option
                v-for="(item, index) in countryList"
                :key="index"
                :label="item.name"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
        </div>
        <div class="enterprise-network_tips">
          <img
            src="@/assets/tool-tip_icon.svg"
            width="18px"
            height="18px"
            alt=""
          />
          <div class="enterprise-network_desc">
            Business registration country/region refers to the country/region
            where a campany is registered. Authorized country/region refers to
            the country/regionwhere the company is approved and authorized to
            carry out transaction by Ruijie.
          </div>
        </div>
      </el-form>
    </div>
  </div>
</template>
<script>
import { getAllCountries } from "../../../../api/international";

export default {
  name: "enterpriseNetworkSelectCountryAndRegionEdit",
  emits:['changeCountry'],
  props: {
    isSeniorEditor: {
      type: Boolean,
      default: false
    },
    defaultCountry: {
      type: String,
      default: ""
    },
    partnerType: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      formData: {
        country: "", // 注册国家
        authRegion: [], // 选择的国家
        authRegionNames: "" // 选择的国家名称
      },
      countryList: [] // 国家列表
    };
  },
  computed: {
    rules() {
      return {
        country: [
          {
            required: true,
            message: "please input  business registration",
            trigger: ["change"]
          }
        ],
        authRegion: [
          {
            required: true,
            message: "please input authorized country",
            trigger: ["change"]
          }
        ]
      };
    }
  },
  methods: {
    searchCountry(callback) {
      getAllCountries()
        .then(response => {
          let { status, data } = response;
          if (Number(status) === 200) {
            this.countryList = data;
            callback && callback(data)
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    // 当注册国家变更的时候
    handleCountryChange(countryCode) {
      this.$emit('changeCountry', countryCode)
    },
    // 选择的授权国家变更的时候
    handleAuthRegionCountryChange(selectCountryCodeList) {
      this.formData.authRegionNames = this.countryList
        .filter(item => selectCountryCodeList.includes(item.code))
        .map(item => item.name)
        .join(",");
    },
    // 设置formData
    setFormData(nextFormData) {
      if (!nextFormData) return;
      this.formData = JSON.parse(JSON.stringify(nextFormData));
    },
    // 获取formData
    getFormData() {
      let isPass = false;
      this.$refs.form.validate(isSuccess => {
        isPass = isSuccess;
      });
      if (isPass) {
        return {
          // 注册国家
          country: this.formData.country,
          // 授权区域
          authRegion: this.formData.authRegion.join(","),
          authRegionNames: this.formData.authRegionNames
        };
      } else {
        return isPass;
      }
    }
  },
  mounted() {
    this.searchCountry((countryList) => {
      if (this.defaultCountry) {
        const country = countryList.find(item => item.name === this.defaultCountry)
        this.formData.country = country.code;
        this.formData.authRegion = [country.code];
        this.formData.authRegionNames = country.name;
      }
    });
  }
};
</script>



// WEBPACK FOOTER //
// src/views/enterpriseNetwork/components/selectCountryAddRegion/selectCountryAddRegionEdit.vue